import { render } from "./BackgroundBlock.vue?vue&type=template&id=960ecddc&scoped=true"
import script from "./BackgroundBlock.vue?vue&type=script&lang=js"
export * from "./BackgroundBlock.vue?vue&type=script&lang=js"

import "./BackgroundBlock.vue?vue&type=style&index=0&id=960ecddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960ecddc"]])

export default __exports__